import React, { Component } from 'react'
import { wrapper } from 'wbap-core-commit'
import { observer } from 'mobx-react'
import Login from './components/Login'
import styles from './style.less'

const {Tab, UserName, Password, Mobile, Captcha, Submit} = Login

@observer
@wrapper()
export default class Page extends Component {
  constructor (props) {
    super(props)
    console.log('login')
    console.log(props)
  }

  render () {
    return (
      <div className={styles.main}>
        <Login defaultActiveKey={this.props.model.data.type} onTabChange={this.props.model.onTabChange}
               onSubmit={this.props.model.onLogin}>
          <Tab key='account' tab='账户密码登录'>
            <UserName name='FCODE' placeholder='用户名'/>
            <Password name='FPASSWORD' placeholder='密码'/>
          </Tab>
          <Tab key='mobile' tab='手机号登录'>
            <Mobile name='mobile' placeholder='手机号'/>
            <Captcha name='captcha' placeholder='验证码'/>
          </Tab>
          <Submit loading={false}>登录</Submit>
        </Login>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-login/page.js